module.exports = __webpack_public_path__ + "img/groupisin.7c9a2107.png";